import { combineReducers } from 'redux'

import { bookReducer, bookServiceInitialState } from './services/Book'
import { userReducer, userServiceInitialState } from './services/User'
import { exerciseReducer, exerciseServiceInitialState } from './services/Exercise'
import { lessonReducer, lessonInitialState } from './services/Lesson'
import { achievementsReducer, achievementsServiceInitialState } from './services/Achievements'
import { libraryInitialState, libraryReducer } from './services/Library'

import { AppState } from './types'

export const initialState: AppState = {
  book: bookServiceInitialState,
  user: userServiceInitialState,
  exercise: exerciseServiceInitialState,
  lesson: lessonInitialState,
  achievements: achievementsServiceInitialState,
  library: libraryInitialState
}

export const combinedReducers = combineReducers({
  book: bookReducer,
  user: userReducer,
  exercise: exerciseReducer,
  lesson: lessonReducer,
  achievements: achievementsReducer,
  library: libraryReducer
})

export const rootReducer = (state = initialState, action: any) => {
  return combinedReducers(state, action)
}
